export default function PHP_gethostname() {
  return (
    <div>
      <h1>PHP_gethostname</h1>
    </div>
  );
}
